export interface WalkNameSnapshot {
  name?: string;
  nameIsUserSet?: boolean;
  updatedAt?: string | Date;
}

/** An extraction/poll response cannot undo a newer acknowledged human rename. */
export function shouldKeepWalkName(current: WalkNameSnapshot, incoming: WalkNameSnapshot): boolean {
  if (!current.nameIsUserSet) return false;
  if (!incoming.nameIsUserSet) return true;
  const savedAt = new Date(current.updatedAt ?? 0).getTime();
  const incomingAt = new Date(incoming.updatedAt ?? 0).getTime();
  return savedAt >= incomingAt;
}

export function normalizeVisitNameInput(raw: string): string | null {
  const trimmed = (raw ?? "").trim().replace(/\s+/g, " ");
  return trimmed ? trimmed.slice(0, 120) : null;
}
